<template>
  <div class="offer-loader font-weight-bold">
    <div class="box-bouncing">
    </div>

    Een moment geduld...
  </div>
</template>

<script>
export default {
  components: {
    //
  },
};
</script>

<style>
.offer-loader {
  background-color: rgba(0, 0, 0, .05);
  padding: 2rem 1rem;
  text-align: center;
}

.box-bouncing {
  width: 3.125rem;
  height: 3.875rem;
  position: relative;
  margin: 0 auto 1rem;
}

.box-bouncing:before {
  content: '';
  width: 3.125rem;
  height: 1.25rem;
  position: absolute;
  bottom: 0;
  left: 0;
  background: black;
  clip-path: polygon(0 50%, 50% 0%, 100% 50%, 50% 100%);
  opacity: .15;
  animation: bouncing-box-shadow 3s ease-in-out infinite;
}

.box-bouncing:after {
  content: '';
  width: 3.125rem;
  height: 3.125rem;
  background: url('/front_assets/img/box.png') no-repeat center center;
  background-size: contain;
  position: absolute;
  top: 0;
  left: 0;
  transform: translateY(.75rem);
  animation: bouncing-box 3s ease-in-out infinite;
}

@keyframes bouncing-box {
  0%,
  100% {
    transform: translateY(.75rem);
  }
  50% {
    transform: translateY(0);
  }
}

@keyframes bouncing-box-shadow {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(.85);
  }
}
</style>
